export const SQUARE_SIZE = 10;
export const WIDTH = window.innerWidth - 100;
export const HEIGHT = window.innerHeight - 100;
export const ROWS = Math.round(HEIGHT / SQUARE_SIZE);
export const COLUMNS = Math.round(WIDTH / SQUARE_SIZE);

export const WALL_GENERATION_ALGO = {
  PRIM: 0,
  KRUS: 1,
};
